import React from 'react';

import SEO from './seo';
import {
  generateJSONLDSchemaArticle,
  generateJSONLDSchemaFAQ,
  generateJSONLDSchemaHowTo,
} from '@utils/seo';
import { SEOType, BlogPostType, HowToSchemaType, FAQsType } from 'src/types';
import useTranslation from 'next-translate/useTranslation';

interface BlogPostSEOprops {
  seo: SEOType;
  url: string;
  seoFAQ?: FAQsType['faq'] | null;
  howToSchema?: HowToSchemaType[] | null;
  articleSchema?: BlogPostType | null;
}

function BlogPostSEO(props: BlogPostSEOprops) {
  const { seo, seoFAQ, url, howToSchema, articleSchema } = props;

  const host_url = process.env.NEXT_PUBLIC_BASE_HOST || 'https://invideo.io';

  const fullUrl = host_url + url;

  const { lang } = useTranslation();
  const Article =
    articleSchema && generateJSONLDSchemaArticle(articleSchema, fullUrl, lang);

  const howTo = howToSchema && generateJSONLDSchemaHowTo(howToSchema, fullUrl);
  const faqSchema = generateJSONLDSchemaFAQ(seoFAQ);

  return (
    <SEO
      title={seo.Title}
      description={seo.Description}
      canonicalurl={seo.CanonicalURL}
      keywords={seo.Keywords}
    >
      {(seo.RobotFollow || seo.RobotIndex) && (
        <meta
          name="robots"
          content={`${seo.RobotFollow || ''}${
            seo.RobotFollow && seo.RobotIndex ? ', ' : ''
          }${seo.RobotIndex || ''}`}
        />
      )}

      {howTo &&
        howTo.map((data, index) => {
          return (
            <script
              key={`howto-` + index}
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
            />
          );
        })}

      {Article &&
        Article.map((data, index) => {
          return (
            <script
              key={`article-` + index}
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
            />
          );
        })}

      {faqSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      )}

      {Array.isArray(seo.Meta) &&
        seo.Meta.map(meta => (
          <meta
            key={'meta-' + meta.id}
            name={meta.Name}
            content={meta.Content}
          />
        ))}

      {Array.isArray(seo.Hreflang) &&
        seo.Hreflang.map(hreflink => (
          <link
            key={'hreflang-' + hreflink.Lang}
            rel="alternate"
            hrefLang={
              hreflink.Lang === 'xdefault' ? 'x-default' : hreflink.Lang
            }
            href={hreflink.Link}
          />
        ))}
    </SEO>
  );
}

export default BlogPostSEO;
